<template>
  <div>
    <apikeys :customerId="getCurrentCustomerId" />
  </div>
</template>
<script>
import apikeys from "../../components/customers/apikeys";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("auth", ["currentUser", "currentUser"]),
    getCurrentCustomerId() {
      const key = this.currentUser.user?.customerCurrent?.customerId ?? 0;
      if (key === 0) {
        window.history.back();
        return 0;
      }
      return key;
    },
  },
  components: {
    apikeys,
  },
};
</script>
